import React from 'react';
import { getFilterFoodData } from '../../helperFunctions/getFilteredFoodData';
import HealthIcon from '@mui/icons-material/Favorite';
import StaminaIcon from '@mui/icons-material/FitnessCenter';
import EitrIcon from '@mui/icons-material/AutoAwesome';
import LocalFireDepartment from '@mui/icons-material/LocalFireDepartment';

interface CookingStationCardProps {
  stationName: string;
  selectedBiomes: string[];
}

const CookingStationCard: React.FC<CookingStationCardProps> = ({ stationName, selectedBiomes }) => {
  // Find all foods that can be made at the given station
  const allFoodsForStation = getFilterFoodData().filter(
    food => food.craftingStation === stationName
  );

  // Filter by selected biomes
  const matchingFoods = allFoodsForStation.filter(
    food => selectedBiomes.includes(food.biomeProgression)
  );

  // If no matching foods, return null
  if (matchingFoods.length === 0) {
    return null;
  }

  // Generate CSS class name from station name
  const stationClassName = `station-${stationName.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <div className={`cooking-station-card ${stationClassName}`}>
      <div className="station-header">
        <div className="station-icon">
          <LocalFireDepartment />
        </div>
        <h2 className="station-name">{stationName}</h2>
        <span className="station-food-count">
          {matchingFoods.length} {matchingFoods.length === 1 ? 'item' : 'items'}
        </span>
      </div>
      
      <div className="station-food-grid">
        {matchingFoods.map(food => (
          <div key={food.name} className="food-card-mini">
            <div className="food-card-title">{food.name}</div>
            <div className="food-stats-row">
              {food.health > 0 && (
                <div className="food-stat-mini" style={{ color: '#ff6b6b' }}>
                  <HealthIcon />
                  {food.health}
                </div>
              )}
              {food.stamina > 0 && (
                <div className="food-stat-mini" style={{ color: '#51cf66' }}>
                  <StaminaIcon />
                  {food.stamina}
                </div>
              )}
              {food.eitr > 0 && (
                <div className="food-stat-mini" style={{ color: '#748ffc' }}>
                  <EitrIcon />
                  {food.eitr}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CookingStationCard;
